<ng-container *ngIf="profilerActive">
    <div id="tile-profiler">
        <div id="tile-profiler-toolbar">
            <div id="tile-profiler-selector">
                <mat-form-field appearance="standard" floatLabel="always">
                    <mat-label>3D Tile Profiler</mat-label>
                    <mat-select [(ngModel)]="selectedLayer" (ngModelChange)="updateClippingPlanes()">
                        <ng-container *ngIf="layerOptions">
                            <ng-container *ngFor="let layer of layerOptions">
                                <mat-option [value]="layer.layer">{{ layer.label }}</mat-option>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!layerOptions">
                            <mat-option value="No suitable layers"></mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <!-- Commented out pending resolution of intermittent crashing. -->
            <!-- <div id="tile-profiler-axis">
                <mat-button-toggle-group [(ngModel)]="selectedAxis" (ngModelChange)="updateSelectedAxis()" name="axis" style="border-radius: 0 4px 4px 0;">
                    <mat-button-toggle value="x">𝑥 axis</mat-button-toggle>
                    <mat-button-toggle value="y">𝑦 axis</mat-button-toggle>
                </mat-button-toggle-group>
            </div> -->
        </div>
    </div>
</ng-container>